export default {
  bases: ['/leads'],
  fetches: [],
  build: () => []
}
